import { Link, useLocation, Navigate } from "react-router-dom";
import { PriorityBadge } from "../components/StatusBadges";

interface ConfirmState {
  incidentNumber: string;
  priority: string;
  status: string;
  submittedAt: string;
  photoAttached?: boolean;
  photoWarning?: string | null;
}

export function ReportConfirmation() {
  const location = useLocation();
  const state = location.state as ConfirmState | null;

  if (!state) return <Navigate to="/report" replace />;

  const submitted = new Date(state.submittedAt).toLocaleString("en-US", {
    dateStyle: "long",
    timeStyle: "short",
  });

  return (
    <div className="container">
      <div className="card confirmation-box">
        <p style={{ fontSize: "2.5rem" }} aria-hidden="true">
          ✅
        </p>
        <h2>Incident Submitted Successfully</h2>
        <p className="confirmation-number">{state.incidentNumber}</p>
        <p>
          <PriorityBadge priority={state.priority} /> <span className="badge badge-status">New</span>
        </p>
        <p className="hint">Submitted: {submitted}</p>
        {state.photoAttached && <p className="hint">📎 Your photo was attached.</p>}
        {state.photoWarning && (
          <div className="alert-banner" role="alert">
            {state.photoWarning}
          </div>
        )}
        <p style={{ marginTop: "1.5rem" }}>
          Thank you. Your technology incident has been submitted to the Christian Church of Latter Rain of
          Philadelphia IT/AVL team.
        </p>
        <div className="home-actions">
          <Link to="/" className="btn btn-secondary">
            Return to Home
          </Link>
          <Link to="/status" className="btn btn-primary">
            Check Incident Status
          </Link>
        </div>
      </div>
    </div>
  );
}
